import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';

interface CriticalChangesDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  bookedCount: number;
  changedLabels: string[];
  onSaveAndNotify: () => void;
  onSaveWithout: () => void;
  isSaving?: boolean;
}

export function CriticalChangesDialog({
  open,
  onOpenChange,
  bookedCount,
  changedLabels,
  onSaveAndNotify,
  onSaveWithout,
  isSaving,
}: CriticalChangesDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" data-testid="critical-changes-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-amber-500 shrink-0" />
            <DialogTitle>Ändringen påverkar anmälda</DialogTitle>
          </div>
          <DialogDescription className="pt-2 text-left">
            {bookedCount} {bookedCount === 1 ? 'person har' : 'personer har'} anmält intresse.
            Du har ändrat:{' '}
            <span className="font-medium text-foreground">
              {changedLabels.join(', ').toLowerCase()}
            </span>.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col gap-2 sm:flex-col">
          <Button
            onClick={onSaveAndNotify}
            disabled={isSaving}
            data-testid="save-and-notify"
          >
            Spara och meddela deltagare
          </Button>
          <Button
            variant="outline"
            onClick={onSaveWithout}
            disabled={isSaving}
            data-testid="save-without-notify"
          >
            Spara utan att meddela
          </Button>
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            disabled={isSaving}
          >
            Avbryt
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
